/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import moment from "moment";
import type { VersionItem } from "../types/types";
import { styled } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
//@ts-ignore
import { HugeiconsIcon } from "@hugeicons/react";
//@ts-ignore
import { MultiplicationSignStrokeStandard } from "@hugeicons-pro/core-stroke-standard";
//@ts-ignore
import { ArrowTurnBackwardIcon } from '@hugeicons-pro/core-stroke-rounded';
import { ARE_YOU_SURE, VERSION_UPDATE } from "src/constants/constant";
import OutlineButton from "../MUICustomButton/OutlineButton";
import GradientButton from "../MUICustomButton/GradientButton";
import Loader from "../Loader";
import { IconButton, TextField } from '@mui/material';
 
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props}  classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.palette.common.black }
}));
 
interface TemplateVersionProps {
  templateVersionData: VersionItem[];
  templateData: any;
  isDisabled: boolean;
  VersionPanelLoading: boolean;
  handleUpdateVersion: (id: number) => void;
  templateName?:string | null;
}
 
function TemplateVersionHistory({
  templateVersionData,
  isDisabled,
  templateData,
  VersionPanelLoading,
  handleUpdateVersion,
  templateName,
}: TemplateVersionProps): JSX.Element {
  const [showVersionUpdateModal, setShowVersionUpdateModal] =
    useState<boolean>(false);
  const [selectedVersionId, seselectedVersionId] = useState<number>(0);
  const [selectedVersionName, seselectedVersionName] = useState<number>(0);
 
  const handleUpdateVersionClose = (): void => {
    setShowVersionUpdateModal(false);
    seselectedVersionId(0);
  };
 
  const handleUpdateVersionConfirm = (): void => {
    handleUpdateVersion(selectedVersionId);
    setShowVersionUpdateModal(false);
  };
 
  const handleUpdateVersionOpen = (
    id: number,
    versionName: number
  ): void => {
    seselectedVersionId(id);
    seselectedVersionName(versionName);
    setShowVersionUpdateModal(true);
  };
 
  return (
    <div className="relative px-[16px] pt-[10px]">
      {/* ✅ Template Name on top */}
      <div
        // className="mb-[20px] w-full"
        className={`mb-[5px] w-full relative role-input-container disabled`}
        style={{ marginBottom: "30px"}}
      >
        <BootstrapTooltip
          title={templateName ?? ""}
        >
          <TextField
            id="outlined-basic"
            label="Template Name"
            variant="outlined"
            fullWidth
            value={templateName ?? ""}
            autoComplete="off"
            InputProps={{
              style: {
                textAlign: "center",
                color: '#343434 !important',
                fontSize: '18px !important',
                fontWeight: '700 !important',
                WebkitTextFillColor: '#343434 !important',
                padding: '9px 14px 9px 25px',

              },

            }}
            sx={{
              '& input': {
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
              '& label': {
                textAlign: 'center',
              },
              backgroundColor: '#F5F5F5',
            }}
            disabled={true}
          />
        </BootstrapTooltip>
      </div>
    <div className="relative min-h-[200px] mt-2">
      {VersionPanelLoading ? (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/80 rounded-lg">
          <Loader />
        </div>
      ) : (
        templateVersionData?.map((item) => {
          const isUpdated = !(item.updatedOn == null);
          const displayDate = isUpdated ? item.updatedOn : item.createdOn;
          const displayName = isUpdated ? item.updatedByName : item.createdByName;
          const isCurrentVersion =
            templateData?.templateVersionId === item.id;
          return (
            <div
              key={item.id}
              style={
                isCurrentVersion
                  ? { backgroundColor: "rgb(245, 245, 245)", color: "#004d40", marginBottom: "5px" }
                  : {marginBottom: "5px"}
              }
              className={`relative rounded-lg p-4 transition hover:shadow-lg ${
                isCurrentVersion
                  ? "border-green-400 shadow-inner"
                  : "bg-white border-gray-300 shadow-inner text-black"
              }`}
            >
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-md font-normal mb-1 flex items-center gap-2" style={{ color: '#3a3a3a' }}>
                    <span>Version {item.version}</span>
                    {isCurrentVersion && (
                      <span
                        className="text-md font-bold"
                        style={{ color: '#3a3a3a' }}
                      >
                        (Current version)
                      </span>
                    )}
                  </div>
 
                  <h3 className="text-16 font-semibold text-muted mb-1" style={{ color: '#3a3a3a' }}>
                    {moment(displayDate, "MM/DD/YYYY HH:mm:ss").format(
                      "MMMM D, h:mm A"
                    )}
                  </h3>
 
                  <div className="text-md font-normal" style={{ color: '#3a3a3a' }}>
                    {isUpdated ? "Updated By" : "Created By"}: {displayName}
                  </div>
                </div>
 
                {/* Icon always visible except for current version */}
                {/* Icon always visible except for current version */}
{!isCurrentVersion && (
  !isDisabled ? (
     <BootstrapTooltip  title="Change to this version">
    <IconButton
      onClick={() => handleUpdateVersionOpen(item.id, item.version)}
      size="small"
      sx={{
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.05)", // round bg on hover
        },
      }}
    >
      <HugeiconsIcon
                icon={ArrowTurnBackwardIcon}
                size={24}
                strokeWidth={0.2}
                color="#3a3a3a"
              />
       
    </IconButton>
    </BootstrapTooltip>
  ): null
)}
 
              </div>
            </div>
          );
        })
      )}
 
      <BootstrapDialog
        onClose={handleUpdateVersionClose}
        aria-labelledby="customized-dialog-title"
        open={showVersionUpdateModal}
        PaperProps={{
          sx: { width: "550px", height: "200px" },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            color: "#3A3A3A",
            fontSize: "18px",
            fontWeight: "600",
          }}
          id="customized-dialog-title"
        >
          Version Update
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleUpdateVersionClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <HugeiconsIcon
            icon={MultiplicationSignStrokeStandard}
            size={24}
            color="currentcolor"
            strokeWidth={0.5}
          />
        </IconButton>
        <DialogContent>
          <p className="text-14 text-muted">
            {ARE_YOU_SURE} {VERSION_UPDATE}{" "}
            <span className="font-semibold">{selectedVersionName}</span>?
          </p>
        </DialogContent>
        <DialogActions sx={{ background: "#F9F9F9" }}>
          <OutlineButton
            color="gray"
            onClick={handleUpdateVersionClose}
            width="100px"
          >
            Cancel
          </OutlineButton>
          <GradientButton
            type="button"
            color="red"
            onClick={handleUpdateVersionConfirm}
            width="100px"
          >
            {"Update"}
          </GradientButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
    </div>
  );
}
 
export default TemplateVersionHistory;